import { useQuery } from '@tanstack/react-query';
import { get } from '@/lib/api';

export interface OfferedPayer {
  id: string;
  name: string;
  code?: string;
}

export const BRANCH_PAYERS_PATH = '/insurance/payers?availableInBranch=true';

export function useBranchPayers(enabled = true) {
  return useQuery({
    queryKey: ['payers', 'branch'],
    queryFn: () => get<OfferedPayer[]>(BRANCH_PAYERS_PATH),
    enabled,
    staleTime: 60_000,
  });
}

export function offeredPayerIds(payers: readonly OfferedPayer[] | undefined): Set<string> | null {
  return payers ? new Set(payers.map((payer) => payer.id)) : null;
}

export function filterOffered<T extends { payerId: string }>(rows: readonly T[], offered: ReadonlySet<string> | null): T[] {
  if (!offered) return [...rows];
  return rows.filter((row) => offered.has(row.payerId));
}
